<template>
  <section v-on:click="sectionClicked" class="features iconSlider" :class="section.id">
    <div class="cnt">
      <div class="sectionHeader" v-if="section.title[lang] || section.descriptions[lang]">
        <h4 class="sectionTitle" v-if="section.title[lang]">{{section.title[lang]}}</h4>
        <p class="sectionDesc" v-if="section.descriptions[lang]">{{section.descriptions[lang]}}</p>
      </div>
      <div class="gallery-nobar-item-cnt" v-if="['gallery-nobar'].includes(section.id)">
        <div class="gallery-nobar-item"
          v-for="(item, i) in section.items" :key="`gn${i}`">
          <div class="card">
            <div class="card-in">
              <div class="card-icon" v-if="item.media[lang]"
                :style="{'background-image': `url(${item.media[lang].imageSm})`}"
                :class="{png: item.media[lang].mimetype === 'image/png'
                || item.media[lang].mimetype === 'image/svg+xml'}"></div>
              <div class="card-icon noImg" v-else></div>
              <h4 class="card-title" v-if="item.title && item.title[lang]"
                v-html="item.title[lang]"></h4>
              <h4 class="card-desc" v-if="item.descriptions && item.descriptions[lang]">
                {{item.descriptions[lang]}}</h4>
              <template v-if="item.url">
                <router-link :to="item.url"
                  class="btn">{{item.buttonLabel[lang]}}</router-link>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="gallery-nobar-item-cnt bye-socmed" v-else-if="['bye-socmed'].includes(section.id)">
        <div class="gallery-nobar-item"
          v-for="(item, i) in section.items" :key="`gn${i}`">
          <div class="card">
            <a :href="item.url" class="card-in" target="_blank">
              <div class="card-icon" v-if="item.media[lang]"
                :style="{'background-image': `url(${item.media[lang].imageSm})`}"
                :class="{png: item.media[lang].mimetype === 'image/png'
                || item.media[lang].mimetype === 'image/svg+xml'}"></div>
              <div class="card-icon noImg" v-else></div>
              <h4 class="card-title" v-if="item.title && item.title[lang]"
                v-html="item.title[lang]"></h4>
              <h4 class="card-desc" v-if="item.descriptions && item.descriptions[lang]">
                {{item.descriptions[lang]}}</h4>
            </a>
          </div>
        </div>
      </div>
      <div class="swiperCnt" v-else>
        <div class="sp spl" v-on:click="prevSlide"></div>
        <div class="sp spr" v-on:click="nextSlide"></div>
        <div class="swiperIn">
          <swiper
            :slidesPerView="1"
            :loop="true"
            :breakpoints="{841:{slidesPerView: 3},641:{slidesPerView: 2}}"
            ref="swiper"
            :centeredSlides="true"
            :pagination="true"
            @swiper="onSwiper">
            <swiper-slide class="swiper-item"
              v-for="(item, i) in section.items" :key="`iconSlider${i}`">
              <div class="card">
                <div class="card-in">
                  <div class="card-icon" v-if="item.media[lang]"
                    :style="{'background-image': `url(${item.media[lang].imageSm})`}"
                    :class="{png: item.media[lang].mimetype === 'image/png'
                    || item.media[lang].mimetype === 'image/svg+xml'}"></div>
                  <div class="card-icon noImg" v-else></div>
                  <h4 class="card-title" v-if="item.title && item.title[lang]">
                    {{item.title[lang]}}</h4>
                  <h4 class="card-desc" v-if="item.descriptions && item.descriptions[lang]">
                    {{item.descriptions[lang]}}</h4>
                  <template v-if="item.url">
                    <router-link :to="item.url"
                      class="btn">{{item.buttonLabel[lang]}}</router-link>
                  </template>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Navigation, Pagination } from 'swiper';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2';
import 'swiper/swiper-bundle.css';

SwiperCore.use([Navigation, Pagination]);

export default {
  name: 'home',
  props: ['section'],
  components: { Swiper, SwiperSlide },
  data() {
    return {
      newsIdx: 0,
      ch: null,
      loading: true,
      swiper: null,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    prevSlide() {
      if (!this.swiper) return;
      this.swiper.slidePrev();
    },
    nextSlide() {
      if (!this.swiper) return;
      this.swiper.slideNext();
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style lang="scss">
.gallery-nobar-item-cnt{
  .gallery-nobar-item{
    .card-title{
      span{
        display: block;
        font-size: 30px;
        margin-top: -15px;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.iconSlider{
  .swiperCnt{
    padding: 0 120px;
    margin: 0 -60px;
    position: relative;
    @media (max-width: 1340px) {
      margin: 0;
      padding: 0 80px;
    }
    @media (max-width: 1060px) {
      padding: 0;
      margin: 0 -10px;
    }
    @media (max-width: 640px) {
      margin: 0 -20px;
    }
    .sp{
      position: absolute;
      width: 50px; height: 50px;
      background-color: #ccc;
      border-radius: 50%;
      top: 50%;
      transform: translateY(-50%);
      opacity: .26;
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .3s ease;
      z-index: 7;
      @media (max-width: 1060px) {
        opacity: 1 !important;
        background-color: #fff;
        width: 40px; height: 40px;
        background-size: 16px auto;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
      }
      @media (max-width: 640px) {
        display: none;
      }
      &:hover{
        opacity: .64;
      }
      &.spl{
        left: 20px;
        background-image: url(../../assets/arrow-left-black.png);
        @media (max-width: 1060px) {
          left: 0;
        }
      }
      &.spr{
        right: 20px;
        background-image: url(../../assets/arrow-right-black.png);
        @media (max-width: 1060px) {
          right: 0;
        }
      }
    }
    .swiper-item{
      transition: all .3s ease;
      &.swiper-slide-active{
        transform: scale(1.1);
        @media (max-width: 840px) {
          transform: none;
        }
        @media (max-width: 640px) {
          transform: scale(1.08);
        }
      }
      .card{
        padding: 40px 20px;
        @media (max-width: 640px) {
          padding: 40px 44px;
        }
        .card-in{
          box-shadow: 0 0.5rem 1rem rgba(0,0,0,.15);
          color: #E9134F;
          padding: 3.125rem 1.875rem;
          position: relative;
          overflow: hidden;
          border: none;
          display: flex;
          flex-direction: column;
          min-width: 0;
          word-wrap: break-word;
          background-color: #fff;
          background-clip: border-box;
          border-radius: .3rem;
          text-align: center;
          width: 100%;
          min-height: 180px;
          @media (max-width: 640px) {
            box-shadow: 0 0.4rem .6rem rgba(0,0,0,.1);
          }
          .card-icon{
            height: 48px; width: 48px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            margin: 0 auto 10px;
            border-radius: 50%;
            @media (max-width: 1140px) {
              width: 44px; height: 44px;
            }
            &.png{
              border-radius: 0;
              background-size: contain;
            }
          }
          .card-title {
            font-size: 1.5rem;
            margin: .5rem 0;
            @media (max-width: 1140px) {
              font-size: 1.3rem;
            }
          }
          .btn {
            color: #E9134F;
            width: max-content;
            height: max-content;
            padding: .5rem 1rem;
            margin-right: auto !important;
            margin-left: auto !important;
            margin-top: .5rem !important;
            border: 1px solid #E9134F;
            border-radius: .25rem;
            font-weight: normal;
            @media (max-width: 1480px) {
              padding: .4rem .8rem;
              font-size: 15px;
            }
            &:focus {
              box-shadow: 0 0 0 .25rem rgba(0,133,82,.5);
            }
            &:hover {
              background-color: #E9134F;
              color: #fff;
              box-shadow: none;
            }
          }
        }
      }
    }
  }
}

/**
 * Custom
 *
 */
.features.iconSlider.gallery-nobar{
  padding: 250px 0 0;
  background-color: #486CB1;
  color: #fff;
  margin-bottom: 200px;
  position: relative;
  @media (max-width: 960px) {
    margin-bottom: 100px;
  }
  @media (max-width: 640px) {
    padding-top: 200px;
  }
  @media (max-width: 540px) {
    margin-bottom: 50px;
  }
  &:after{
    content: "";
    position: absolute;
    height: 200px; bottom: -200px;
    left: 0; right: 0;
    background-image: url(../../assets/blue-divider-bottom.png);
    background-size: 100% auto;
    background-position: top center;
    background-repeat: no-repeat;
  }
  .sectionTitle{
    font-family: 'Bebas Neue', sans-serif;
    color: #FF9100;
    font-size: 54px;
    letter-spacing: 1.4px;
    line-height: 1.1;
    @media (max-width: 960px) {
      font-size: 46px;
    }
  }
}
.gallery-nobar-item-cnt{
  display: flex;
  justify-content: space-evenly;
  padding: 50px 0 0;
  @media (max-width: 680px) {
    display: block;
  }
  .gallery-nobar-item{
    @media (max-width: 680px) {
      padding: 0 0 60px;
    }
    .card-icon{
      width: 180px; height: 180px;
      border-radius: 50%;
      background-color: #FFCC00;
      background-size: auto 80px;
      background-position: center;
      background-repeat: no-repeat;
      margin: 0 0 16px;
      @media (max-width: 940px) {
        width: 160px; height: 160px;
        background-size: auto 68px;
      }
      @media (max-width: 680px) {
        margin: 0 auto 16px;
      }
    }
    .card-title{
      font-size: 48px;
      font-family: 'Bebas Neue', sans-serif;
      color: #FF9100;
      text-align: center;
      margin: 0;
    }
  }
  &.bye-socmed{
    .gallery-nobar-item{
      .card-icon{
        margin: 0 auto 10px;
        width: 180px; height: 100px;
        border-radius: 0;
        @media (max-width: 840px) {
          width: 140px; height: 100px;
          background-size: auto 54px;
        }
      }
      .card-title{
        font-size: 24px;
        letter-spacing: 1px;
        color: #222;
        @media (max-width: 840px) {
          font-size: 20px;
        }
      }
    }
  }
}

.features.iconSlider.bye-socmed{
  padding: 260px 0 140px;
  @media (max-width: 680px) {
    padding: 160px 0 10px;
  }
}
</style>
